import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function Login({ onLogin }: { onLogin: (user: any, token: string) => void }) {
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      navigate('/chat'); // ✅ Redirect away from login
    }else{
      navigate('/');
    }
  }, []);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    try {
      const res = await axios.post('https://app.r2p.app/server/login.php', { email, password });
      const { user, accessToken } = res.data;
      localStorage.setItem('token', accessToken);
      onLogin(user, accessToken);
    } catch (err: any) {
      setError('Invalid credentials');
    }
  };

  return (
    <div className="h-screen flex flex-wrap items-center justify-center bg-gray-100">
      <div>
        <h2 className="text-3xl font-bold text-center text-blue-600 mb-6">🔐 ParkChat</h2>
        <form onSubmit={handleSubmit} className="bg-white p-6 rounded shadow w-80">
          
          <h2 className="text-xl mb-4 font-bold">Login</h2>
          {error && <div className="text-red-500 mb-2">{error}</div>}
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="border px-3 py-2 w-full mb-3 rounded"
            placeholder="Email"
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="border px-3 py-2 w-full mb-4 rounded"
            placeholder="Password"
          />
          <button type="submit" className="bg-blue-600 text-white px-4 py-2 w-full rounded">
            Log In
          </button>
        </form>
      </div>
    </div>
  );
}
